<div class="fixed inset-0 z-50 flex items-center justify-center p-4" style="background: rgba(15,23,42,0.5);">
  <div class="excess-modal-panel w-full max-w-[560px] bg-white"
    style="border-radius: 16px; padding: 24px; box-shadow: 0 20px 25px -5px rgba(15,23,42,.15);"
    role="dialog" aria-modal="true" aria-labelledby="excess-summary-title">
    <div class="flex items-center gap-2">
      <svg class="h-5 w-5 shrink-0" style="color: #059669;" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <h2 id="excess-summary-title" style="font-size: 18px; font-weight: 600; color: #0F172A;">
        Plan actualizado — excedentes generados
      </h2>
    </div>

    <div class="mt-4 overflow-x-auto">
      <table class="w-full text-left" style="font-size: 14px; color: #0F172A; font-variant-numeric: tabular-nums;">
        <thead>
          <tr style="border-bottom: 1px solid #E2E8F0;">
            <th scope="col" class="py-2 pr-3" style="font-size: 12px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em; color: #64748B;">Cuota #</th>
            <th scope="col" class="py-2 pr-3" style="font-size: 12px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em; color: #64748B;">Comprobante origen</th>
            <th scope="col" class="py-2 pr-3 text-right" style="font-size: 12px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em; color: #64748B;">Monto</th>
            <th scope="col" class="py-2" style="font-size: 12px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em; color: #64748B;">Acción</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items" style="border-bottom: 1px solid #E2E8F0; height: 44px;">
            <td class="pr-3">{{ item.installmentNumber }}</td>
            <td class="pr-3">#{{ item.receiptId }}</td>
            <td class="pr-3 text-right">{{ item.amount | currency:'COP':'symbol-narrow':'1.0-0' }}</td>
            <td>
              <a [routerLink]="['/dashboard/excess-payments', item.excessPaymentId]"
                class="rounded hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
                style="color: #1D4ED8; --tw-ring-color: #2563EB;">Ver excedente</a>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr style="height: 44px; font-weight: 600;">
            <td colspan="2" class="pr-3">Total</td>
            <td class="pr-3 text-right">{{ total | currency:'COP':'symbol-narrow':'1.0-0' }}</td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>

    <div class="mt-6 flex justify-end">
      <button #closeButton type="button" (click)="close()"
        class="px-5 text-white hover:bg-[#1E293B] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
        style="background: #0F172A; height: 44px; border-radius: 12px; font-size: 14px; font-weight: 600; --tw-ring-color: #2563EB;">
        Entendido
      </button>
    </div>
  </div>
</div>
